// extracted by mini-css-extract-plugin
export default {"outer":"Cans2_outer__uzl4i","inner":"Cans2_inner__8SVaq","can":"Cans2_can__hzIbk","fruit1":"Cans2_fruit1__Bx7xv","fruit2":"Cans2_fruit2__26jAH"};